<template lang="html">
	<!-- <?xml version="1.0" encoding="UTF-8"?> -->
	<svg 
		width="100%" 
		class="gradient" 
		height="100%" 
		viewBox="0 0 80 80" 
		version="1.1" 
		xmlns="http://www.w3.org/2000/svg" 
		xmlns:xlink="http://www.w3.org/1999/xlink">
		<defs>
			<linearGradient 
				x1="0%" 
				y1="0%" 
				x2="100%" 
				y2="100%" 
				:id="'gradient'+id">
				<stop 
					:stop-color="'#'+colors.start" 
					offset="0%"/>
				<stop 
					:stop-color="'#'+colors.stop" 
					offset="100%"/>
			</linearGradient>
		</defs>
		<g 
			:id="id" 
			stroke="none" 
			stroke-width="1" 
			fill="none" 
			fill-rule="evenodd">
			<rect 
				:id="'Rectangle'+id" 
				:fill="`url(#gradient${id})`" 
				x="0" 
				y="0" 
				width="80" 
				height="80"/>
		</g>
	</svg>
</template>

<script>
export default {
	props: ['value'],
	data() {
		return {
			id: Math.round(Math.random() * 10000)
		}
	},
	computed: {
		hash() {
			return Math.abs(
				djb2Code(this.value.toString() || Math.round().toString())
			)
		},
		colors() {
			const zeros = Math.round(Math.log(this.hash) / Math.LN10)
			const hash = this.hash / 10 ** zeros + 1
			const start = hslToRgb(hash, 1, 0.6)
			const stop = hslToRgb(hash + (0.7 % 1), 1, 0.6)
			return {
				start: `${start[0].toString(16)}${start[1].toString(
					16
				)}${start[2].toString(16)}`,
				stop: `${stop[0].toString(16)}${stop[1].toString(16)}${stop[2].toString(
					16
				)}`
			}
		}
	}
}

const djb2Code = function(str) {
	let hash = 5381
	for (let i = 0; i < str.length; i++) {
		const char = str.charCodeAt(i)
		hash = (hash << 5) + hash + char /* Hash * 33 + c */
	}
	return hash
}

function hslToRgb(h, s, l) {
	let r
	let g
	let b

	if (s == 0) {
		r = g = b = l // Achromatic
	} else {
		const hue2rgb = function hue2rgb(p, q, t) {
			if (t < 0) t += 1
			if (t > 1) t -= 1
			if (t < 1 / 6) return p + (q - p) * 6 * t
			if (t < 1 / 2) return q
			if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
			return p
		}

		const q = l < 0.5 ? l * (1 + s) : l + s - l * s
		const p = 2 * l - q
		r = hue2rgb(p, q, h + 1 / 3)
		g = hue2rgb(p, q, h)
		b = hue2rgb(p, q, h - 1 / 3)
	}
	return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)]
}
</script>

<style lang="css">
</style>
